
export const COURIER_COMPANY = [
  {
    value: '德邦快递',
  },
  {
    value: '京东快递',
  },
  {
    value: '顺丰快递',
  },
  {
    value: '中通快递',
  },
  {
    value: '申通快递',
  },
  {
    value: '圆通快递',
  },
  {
    value: '百世汇通',
  },
  {
    value: '韵达快递',
  },
  {
    value: '极兔快递',
  },
  {
    value: '优速快递',
  },
  {
    value: '邮政EMS',
  },
  {
    value: '天天快递',
  },
  {
    value: '其他',
  },
];

export const DRUG_ORDER_STATUS = {
  12701: "待支付",
  12702: "待发货",
  12703: "待收货",
  12704: "已完成",
};

export const PAY_TYPE = {
  10101: "支付宝",
  10102: "微信",
};

export const PRESCRIPTTION_DRUG_TYPE = {
  0: "非处方药",
  1: "处方药",
};

export const DRUG_TYPE = {
  1: "西药",
  2: "中成药",
  3: "草药",
};

export const UPLOAD_STATUS = {
  10601: "待备案",
  10602: "备案成功",
  10603: "备案失败",
};

export const UP_STATUS = {
  1: "已上架",
  2: "已下架",
  3: "未上架",
};